"use strict";

exports.__esModule = true;
exports.other = void 0;

var _core = require("../core");

const config = {
  animation: true,
  appearance: true,
  cursor: true,
  float: true,
  objectFit: true,
  objectPosition: true,
  outline: true,
  outlineOffset: true,
  pointerEvents: true,
  resize: true,
  transform: true,
  transformOrigin: true,
  userSelect: true,
  visibility: true,
  willChange: true
};
const other = (0, _core.system)(config);
exports.other = other;